// Splash shown while AuthContext is in status="loading" — i.e.
// during initial token validation on mount. Keeping this brief
// and themed; the typical loading window is sub-second so a
// progress indicator + the app name is enough.

import { Loader2 } from "lucide-react";

export function SplashScreen() {
  return (
    <div
      data-testid="splash-screen"
      className="h-screen flex flex-col items-center justify-center bg-theme-bg-app gap-3"
    >
      <Loader2
        className="w-6 h-6 text-theme-text-tertiary animate-spin"
        strokeWidth={1.5}
        aria-hidden
      />
      <p className="font-mono text-[11px] uppercase tracking-widest text-theme-text-tertiary">
        Slack Archive Viewer
      </p>
    </div>
  );
}
